import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Globals } from "app/globals";

//no authorization
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class RatersService {

    url: string = `${this._Globals.serviceUrl}/RatersService.svc/`;

    constructor(
        private httpClient: HttpClient,
        public _Globals: Globals
    ) { }

    getClientRaterAssignmentDetails(clientRaterAssignmentId: number) {

        let url = `${this.url}GetClientRaterAssignmentDetails?clientRaterAssignmentId=${clientRaterAssignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');
        //.set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    checkAssignmentRatersConversionRate(assignmentId) {

        let url = `${this.url}CheckAssignmentRatersConversionRate?assignmentId=${assignmentId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getAssessments() {

        let url = `${this.url}GetAssessments?raterId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    //{"id":[ASSIGNMENT ID]}
    public getAssessmentDetails(assessmentId: number): Observable<any> {

        let url = `${this.url}GetAssessmentDetails`;
        
        let assessmentDetails: any = {
            "id": assessmentId
        };

        let body = JSON.stringify(assessmentDetails);
        console.log('body GetAssessmentDetails: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'
        });

        return this.httpClient.post(url, body, { headers });
    }

    getAssignmentRatersConversionRate(assignmentId: number) {

        let url = `${this.url}GetAssignmentRatersConversionRate?assignmentId=${assignmentId}&coachId=${this._Globals.getUserId()}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    public postSendEmail(assignmentId: number, raterIds: number[]): Observable<any> {

        let url = `${this.url}SendEmail`;

        let body: any = {
            assignmentId: assignmentId,
            raterIds: raterIds
        }
        body = JSON.stringify(body);
        console.log('body sendEmail: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    getCheckRatersTypesMinimum(raterTypes:string) {
        let url = `${this.url}CheckRatersTypesMinimum?raterTypes=${raterTypes}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getClientRaterAssignmentDetailsForActivation(clientRaterAssignmentId: number, activationCode: string) {
          let url = `${this.url}HX9?wd=${clientRaterAssignmentId}&uv=${activationCode}`;
        //let url = `http://localhost:54541/RatersService.svc/HX9?wd=${clientRaterAssignmentId}&uv=${activationCode}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json');

        return this.httpClient.get(url, { headers: headers });
    }

    public postSaveCommentsData(encriptedData: string): Observable<any> {
        let url = `${this.url}NF89`;
        // let url = `http://localhost:54541/RatersService.svc/NF89`;

        let body: any = {
            'wp9': encriptedData
        }

        body = JSON.stringify(body);
        console.log('postSaveCommentsData body: ' + body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json'//,
            // 'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    public exporRaterComments(assignmentId: number): Observable<any> {

        let url = `${this.url}LW56`;

        let body: any = {
            "vr4": assignmentId
        }

        body = JSON.stringify(body);
        console.log('body exporRaterComments: ', body);

        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + this._Globals.getToken()
        });

        return this.httpClient.post(url, body, { headers });
    }

    //RatersService.svc/MT34?fr={assignmentId}&pt={raterId}
    getCopyRaterLink(clientRaterAssignmentId: number, raterId: number) { //TODO: check use
        let url = `${this.url}MT34?fr=${clientRaterAssignmentId}&pt=${raterId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }

    getCopyRaterLinkWithActivationCode(clientRaterAssignmentId: number, raterId: number) {
/*        let url = `http://localhost:54541/RatersService.svc/MT344?fr=${clientRaterAssignmentId}&pt=${raterId}`;*/
        let url = `${this.url}MT344?fr=${clientRaterAssignmentId}&pt=${raterId}`;

        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('authorization', 'Bearer ' + this._Globals.getToken());


        return this.httpClient.get(url, { headers: headers });
    }
}